import SettingBase from '../settings/util/SettingBase'

class TruckController extends SettingBase {
  /*@ngInject*/
  constructor($state) {
    super();
    this.$state = $state
    this.id = "truck"
    this.acl = {}
    this.hasACL = {}

  }
  $onInit() {
    super.$onInit()
    for (let key in this.acl['setting-' + this.id]) {
      this.hasACL[this.acl['setting-' + this.id][key]] = true;
    }
  }
}

export default TruckController;


// WEBPACK FOOTER //
// ./client/app/components/truck/truck.controller.js